import { HlaAttributeFiltersPopover } from "./HlaAttributeFiltersPopover";
import { HlaAttributeFiltersTags } from "./HlaAttributeFiltersTags";

export const HlaAttributeFilters = () => {
  return (
    <>
      <HlaAttributeFiltersPopover />
      <HlaAttributeFiltersTags />
    </>
  );
};
